var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('sticky-bar',[_vm._v("Page Not Found")]),_c('p',[_vm._v("The requested page does not exist. Try visiting your "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("diagnostics dashboard")]),_vm._v(".")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }